import { ReactNode, useRef } from "react";
import styled from "styled-components";

import COLORS from "components/atoms/colors";
import { TextSm } from "components/atoms/text";

import { InputChange } from "types/Form";

import { ReactComponent as IconCheckGray } from "assets/images/common/check-gray.svg";
import { ReactComponent as IconCheckWhite } from "assets/images/common/check-white.svg";

interface Props {
  name?: string;
  checked?: boolean;
  onChange?: (e: InputChange) => void;
  labelText?: string;
  children?: ReactNode;
  className?: string;
}

const CheckBox = ({
  name,
  checked,
  onChange,
  labelText,
  children,
  className,
}: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <div
      onClick={() => ref.current?.click()}
      className={`flex items-center gap-1 cursor-pointer ${className}`}
    >
      <CheckWrap checked={checked}>
        <input
          ref={ref}
          name={name}
          className="hidden"
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        {checked ? <IconCheckWhite /> : <IconCheckGray />}
      </CheckWrap>
      {children || (
        <TextSm className={`${checked ? "text-black-100%" : "text-black-40%"}`}>
          {labelText}
        </TextSm>
      )}
    </div>
  );
};

const CheckWrap = styled.span<{ checked?: boolean }>`
  flex: none;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid ${COLORS.black["20%"]};
  border-radius: 2px;
  width: 20px;
  height: 20px;
  border-width: ${({ checked }) => (checked ? 0 : "1px")};
  background-color: ${({ checked }) =>
    checked ? COLORS.primary.active : "#fff"};
`;

export default CheckBox;
